import type { FC, ReactNode } from "react";

import { Box, BoxSection, Typography } from "@aviary";
import { useBreakpoints } from "@shared/hooks";

import * as styles from "./ErrorBox.styles";

interface Props {
  error: ReactNode;
  subMessage?: string;
}

const ErrorBox: FC<Props> = ({ error, subMessage }) => {
  const { phoneLarge } = useBreakpoints();
  const typographySize = phoneLarge.greaterThan ? "body" : "footnote";

  return (
    <Box isBordered isColor="danger" css={styles.box} data-testid="sign-up-error-box">
      <BoxSection isPaddingless>
        <Typography isFullWidth isSecondaryWeight={!!subMessage} type={typographySize}>
          {error}
        </Typography>
        {subMessage && (
          <Typography isFullWidth type={typographySize}>
            {subMessage}
          </Typography>
        )}
      </BoxSection>
    </Box>
  );
};

export { ErrorBox };
